import type { HasAccessArgs } from "../root/layout/SidebarMenuItem";
import { useGetHasAccessArgs } from "../root/layout/SidebarMenuItem";

export const hasAssistantAccess = ({ hasPermission, currentOrganisation }: HasAccessArgs) =>
  (currentOrganisation.enabledFeatures ?? []).includes("FormAssistant") &&
  hasPermission("nova-forms-api:assistant:use");

export const useAssistantAccess = () => hasAssistantAccess(useGetHasAccessArgs());

export type AssistantStartState = { startsRegistration?: boolean } | null;
